module.exports = __webpack_public_path__ + "static/media/playground-min.9b2ea82f.ogg";